import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BrutalistFeatures = () => {
  const containerRef = useRef(null);
  
  // Mock data for the typewriter effect
  const telemetryLogs = [
    "[22:04] Вход авторизован",
    "[22:06] Камера активна",
    "[22:08] Датчик в норме",
    "[22:12] Объект защищён"
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate cards on scroll
      gsap.from('.feature-card', {
        y: 100,
        opacity: 0,
        duration: 0.8,
        stagger: 0.2,
        scrollTrigger: {
          trigger: containerRef.current,
          start: 'top 80%',
        }
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={containerRef} className="py-24 px-6 bg-background text-foreground relative z-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Card 1: Diagnostic Shuffler */}
        <div className="feature-card border border-border bg-card p-8 hover:translate-y-[-4px] transition-transform duration-300 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
          <div className="h-12 w-12 bg-accent/10 flex items-center justify-center mb-6">
            <div className="w-3 h-3 bg-accent animate-ping" />
          </div>
          <h3 className="text-2xl font-bold font-sans mb-4 uppercase tracking-tight">Цифровой доступ</h3>
          <ul className="space-y-3 font-mono text-sm text-muted-foreground">
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-accent" /> Индивидуальный код
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-accent" /> Контроль входа
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-accent" /> История посещений
            </li>
          </ul>
        </div>

        {/* Card 2: Telemetry Typewriter */}
        <div className="feature-card border border-border bg-black text-white p-8 hover:translate-y-[-4px] transition-transform duration-300 shadow-[4px_4px_0px_0px_rgba(230,59,46,1)]">
          <div className="flex justify-between items-start mb-6">
            <div className="h-3 w-3 bg-red-500 rounded-full animate-pulse" />
            <span className="font-mono text-xs text-gray-500">ОНЛАЙН</span>
          </div>
          <h3 className="text-2xl font-bold font-sans mb-4 uppercase tracking-tight text-white">Мониторинг 24/7</h3>
          <div className="font-mono text-xs text-green-400 space-y-2">
            {telemetryLogs.map((log, i) => (
              <div key={i} className="opacity-80">{log}</div>
            ))}
            <span className="inline-block w-2 h-4 bg-green-400 animate-pulse ml-1" />
          </div>
        </div>

        {/* Card 3: Scheduler */}
        <div className="feature-card border border-border bg-card p-8 hover:translate-y-[-4px] transition-transform duration-300 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
          <div className="h-12 w-12 border border-black flex items-center justify-center mb-6">
            <span className="font-mono text-xl font-bold">24</span>
          </div>
          <h3 className="text-2xl font-bold font-sans mb-4 uppercase tracking-tight">Гибкие условия</h3>
          <div className="grid grid-cols-7 gap-1 font-mono text-xs text-center mb-6">
            {['П', 'В', 'С', 'Ч', 'П', 'С', 'В'].map((d, i) => (
              <div key={i} className={`p-1 ${i > 4 ? 'text-accent' : 'text-foreground'}`}>{d}</div>
            ))}
          </div>
          <button className="w-full py-2 border border-black font-mono text-xs uppercase hover:bg-black hover:text-white transition-colors">
            Сохранить
          </button>
        </div>

      </div>
    </section>
  );
};

export default BrutalistFeatures;
